import React from 'react';
import { Button } from 'reactstrap';
import './view-event-form-actions.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  onCancelEvent: () => void;
  onCloseModal: () => void;
  isWaitingList?: boolean;
};

const ViewEventFormActions = ({
  onCancelEvent,
  onCloseModal,
  isWaitingList,
}: Props) => {
  const { t } = useTranslation();
  return (
    <div className="book-event-form-actions">
      <Button
        className="confirm-booking-event-button"
        type="button"
        onClick={onCancelEvent}
        color="transparent"
        style={{ backgroundColor: '#ea5455', color: 'white' }}
      >
        {isWaitingList
          ? t('REMOVE_FROM_WAITING_LIST_BUTTON')
          : t('CANCEL_EVENT')}
      </Button>
      <Button
        className="cancel-booking-event-button"
        type="button"
        color="transparent"
        onClick={onCloseModal}
      >
        {t('CLOSE_BUTTON')}
      </Button>
    </div>
  );
};

export default ViewEventFormActions;
